import { createAction } from '@reduxjs/toolkit';

export const resetJourney = createAction('RESET_JOURNEY');
